import { createSlice } from "@reduxjs/toolkit";
import { createFaculty, editFaculty, getBank, getBillingInfo } from "../../builders/addFaculty/add-faculty.builder";

const initialState = {
  allFacultyData: [],
  allBankData: [],
  allBillingInfo:[],
  formEditId : null,
  loading : false,
};

const addFacultySlice = createSlice({
  name: "addFaculty",
  initialState,
  reducers: {
    setFormEditId : (state, action) => {
      state.formEditId =  action.payload
    },
    clearExtraReducers : (state) => {
      state.allFacultyData = [],
      state.allBankData = [],
      state.allBillingInfo=[],
      state.formEditId = null,
      state.loading = false
  } 
  },
  extraReducers: (builder) => {

    builder.addCase(editFaculty.pending, (state) => {
      state.loading = true
    });
    builder.addCase(editFaculty.fulfilled, (state) => {
      state.loading = false  
    });
    builder.addCase(editFaculty.rejected, (state) => {
      state.loading = false
    });

    //create faculty
    builder.addCase(createFaculty.pending, (state) => {
      state.loading = true
    });
    builder.addCase(createFaculty.fulfilled, (state, action) => {
      
      state.loading = false;
      state.allFacultyData = action.payload;
    });
    builder.addCase(createFaculty.rejected, (state) => {
      state.loading = false
    });

    //get billing info
    builder.addCase(getBillingInfo.pending, (state) => {
      state.loading = true
    });
    builder.addCase(getBillingInfo.fulfilled, (state, action) => {
      state.loading = false
      state.allBillingInfo = action.payload
    });
    builder.addCase(getBillingInfo.rejected, (state) => {
      state.loading = false
    });

    //get Banks
    builder.addCase(getBank.pending, (state) => {
      state.loading = true
    });
    builder.addCase(getBank.fulfilled, (state, action) => {
      state.loading = false
      state.allBankData = action?.payload
    //   const bankData = action?.payload?.map((bank)=>{
    //     return { label: bank.bankName, value: bank.bankId }
    // })
    //    state.bank = bankData;
    });
    builder.addCase(getBank.rejected, (state) => {
      state.loading = false
    });
  },
});

export const { setFormEditId  } = addFacultySlice.actions;

export default addFacultySlice.reducer;
